import React from 'react';
import { z } from 'zod';
import { Input } from '@/components/ui/input';
import { useFormContext } from 'react-hook-form';
import { QuestionData } from '../types';

interface FileFieldProps {
  question: QuestionData;
  placeholder?: string;
  disabled?: boolean;
}

const FileFieldComponent: React.FC<FileFieldProps> = ({
  question,
  disabled,
}) => {
  const { register } = useFormContext();
  return (
    <Input
      {...register(question.slug)}
      type="file"
      className="w-full"
      disabled={disabled}
    />
  );
};

const createSchema = (question: QuestionData): z.ZodTypeAny => {
  const schema = z.union([
    z.instanceof(File),
    z.object({
      name: z.string(),
      url: z.string().url(),
      size: z.number().optional(),
      type: z.string().optional(),
    }),
    z.string(),
  ]);

  return question.required
    ? schema.nullable().refine(val => val !== null, {
        message: 'This field is required',
      })
    : schema.optional().nullable();
};

const getDefaultValue = (): null => null;

export const FileField = {
  component: FileFieldComponent,
  createSchema,
  getDefaultValue,
};
